export default {
	tabs: ["Depozyt", "Historia"],
	History: {
		tabs: ["Przegląd", "Sukces", "Odrzucić"]
	},
	AccountAmount: "Kwota konta",
	ContactCustomerService: "Kontakt z działem obsługi klienta",
	NoCustomerService: "Zapracowana obsługa klienta",
	tips: "Prosimy o przesłanie poprzedniej oceny przed przejściem do następnej!"
};
